import { Status } from "@/schema/Status";
import { atom, useAtom } from "jotai";

const statusesAtom = atom([] as Status[]);

function useStatuses() {
  const [statuses, setStatuses] = useAtom(statusesAtom)

  return {
    statuses,
    setStatuses
  }
}

export default useStatuses